///////////////////////////////////////////////////
/// User Settings
///////////////////////////////////////////////////

/// These URLs should contain the slash at the end
export const API_BASE_URL =
  "https://05eklhb23h.execute-api.eu-central-1.amazonaws.com/dev/";
export const MESSAGING_URL =
  "wss://guvcpqcffb.execute-api.eu-central-1.amazonaws.com/dev/";
